import * as React from 'react';

import Checkbox from 'components/Checkbox';
import { Props as CheckboxProps } from 'components/Checkbox';
import UserAvatar from 'users/components/UserAvatar';
import { Props as UserAvatarProps } from 'users/components/UserAvatar';

import getField from '../ComposableTableField';
import { Field } from '../ComposableTableField';

import './ComposableTable-UserAvatarCheckboxCell.scss';

export function getUserAvatarCheckboxCellGenerator<T>(input: {
  checkboxProps?: Partial<CheckboxProps>;
  checked: (arg0: any) => boolean;
  fieldForAction?: Field<T>;
  hideAvatar?: boolean;
  onAvatarClickAction: (event: React.SyntheticEvent, arg1: any) => void;
  onCheckboxClickAction: (event: React.SyntheticEvent, arg1: any) => void;
  userAvatarProps?: Partial<UserAvatarProps>;
  userField?: Field<T>;
}) {
  return (data: T) => {
    return (
      <div className="ComposableTable-UserAvatarCheckboxCell">
        <Checkbox
          {...input.checkboxProps}
          checked={input.checked(getField(data, input.fieldForAction ?? null))}
          readOnly
          className="ComposableTable-UserAvatarCheckboxCell-checkbox"
          onClick={event =>
            input.onCheckboxClickAction(event, getField(data, input.fieldForAction ?? null))
          }
        />
        {!input.hideAvatar && (
          <UserAvatar
            {...input.userAvatarProps}
            user={getField(data, input.userField ?? null)}
            size="medium"
            className="ComposableTable-UserAvatarCheckboxCell-avatar"
            onClick={e =>
              input.onAvatarClickAction(e, getField(data, input.fieldForAction ?? null))
            }
          />
        )}
      </div>
    );
  };
}
